{
  "auth": {
    "emailOrUsername": "E-mail nebo uživatelské jméno",
    "emailOrUsernamePlaceholder": "Zadejte e-mail nebo uživatelské jméno",
    "passwordPlaceholder": "Zadejte heslo",
    "signInSubtitle": "Přihlaste se ke svému účtu pro pokračování",
    "rememberMe": "Zapamatovat si mě",
    "forgotPassword": "Zapomenuté heslo?",
    "signIn": "Přihlásit se",
    "signingIn": "Přihlašuji...",
    "noAccount": "Nemáte účet?",
    "requestAccess": "Požádat o přístup",
    "requiredField": "Toto pole je povinné",
    "emailOrUsernameRequired": "E-mail nebo uživatelské jméno je povinné",
    "invalidEmailOrUsername": "Zadejte platnou e-mailovou adresu nebo uživatelské jméno",
    "verifyingCredentials": "Ověřuji vaše přihlašovací údaje...",
    "signInSuccess": "Úspěšně jste se přihlásili! Vítejte zpět.",
    "loginFailed": "Přihlášení se nezdařilo. Zkuste to prosím znovu."
  },
  "common": {
    "theme": "Motiv"
  },
  "language": {
    "english": "Angličtina",
    "czech": "Čeština"
  },
  "Traffic": "Provoz",
  "Dashboard": "Přehled",
  "Data": "Data",
  "Reports": "Reporty",
  "reportCategories": {
    "dailyHourly": "Denní hodinové",
    "dailyHourlyDesc": "Analýza po dnech a hodinách",
    "timeSeries": "Časová řada",
    "dailyMonthly": "Denní měsíční",
    "dailyMonthlyDesc": "Porovnání denních a měsíčních údajů",
    "timeline": "Časová osa",
    "monthly": "Měsíční",
    "monthlyDesc": "Analýza měsíčních trendů",
    "yearly": "Roční",
    "yearlyDesc": "Roční výkonnost",
    "annual": "Roční"
  },
  "reportModal": {
    "configuration": "Nastavení",
    "configureParams": "Nastavte parametry pro report {category}:",
    "monthRangeSelection": "Výběr rozsahu měsíců",
    "selectMonthRange": "Vyberte rozsah měsíců pro porovnání",
    "startMonth": "Počáteční měsíc",
    "endMonth": "Koncový měsíc",
    "startYear": "Počáteční rok",
    "endYear": "Koncový rok",
    "placeholderStartMonth": "Počáteční měsíc",
    "placeholderEndMonth": "Koncový měsíc",
    "placeholderStartYear": "Počáteční rok",
    "placeholderEndYear": "Koncový rok",
    "last3Months": "Poslední 3 měsíce",
    "last6Months": "Posledních 6 měsíců",
    "thisYear": "Tento rok",
    "lastYear": "Minulý rok",
    "dateRange": "Rozsah dat",
    "selectDateRangeDaily": "Vyberte rozsah dat pro denní analýzu",
    "startDate": "Počáteční datum",
    "endDate": "Koncové datum",
    "placeholderStartDate": "Vyberte počáteční datum",
    "placeholderEndDate": "Vyberte koncové datum",
    "yearRangeSelection": "Výběr rozsahu roků",
    "selectYearRange": "Vyberte rozsah roků pro porovnání",
    "last3Years": "Poslední 3 roky",
    "last5Years": "Posledních 5 let",
    "last10Years": "Posledních 10 let",
    "thisDecade": "Toto desetiletí",
    "dateTimeRange": "Datum a čas",
    "startTime": "Počáteční čas",
    "endTime": "Koncový čas",
    "placeholderStartTime": "00:00",
    "placeholderEndTime": "23:59",
    "configurationSection": "Nastavení",
    "enableAINarrations": "Povolit AI generované popisy reportů",
    "aiNarrationsHint": "Generovat shrnutí a přehledy pro každou sekci reportu",
    "aiModelHint": "Používá model Hugging Face T5 pro profesionální popisy sekcí",
    "testAIConnection": "Otestovat připojení AI",
    "station": "Stanice",
    "loadingStations": "Načítání stanic...",
    "selectStation": "Vyberte stanici",
    "reportType": "Typ reportu",
    "exportFormat": "Formát exportu",
    "selectFormat": "Vyberte formát",
    "selectType": "Vyberte typ",
    "previewConfiguration": "Náhled nastavení",
    "timeRange": "Časový rozsah",
    "aiGeneration": "AI generování",
    "notSet": "Nenastaveno",
    "enabled": "Zapnuto",
    "disabled": "Vypnuto",
    "noteFixedReportType": "Typ reportu je pevně \"{type}\" a nelze změnit",
    "aiNoteInsights": "Budou vygenerována shrnutí pro každou sekci reportu",
    "cancel": "Zrušit",
    "generateReport": "Vygenerovat report",
    "loadingReport": "Načítání dat reportu...",
    "loadingReportHint": "Počkejte, načítáme a zpracováváme data",
    "noDataFound": "Data nebyla nalezena",
    "searchAgain": "Hledat znovu",
    "close": "Zavřít",
    "connectionError": "Chyba připojení",
    "tryAgain": "Zkusit znovu",
    "exportSuccessful": "Export proběhl úspěšně!",
    "reportTitle": "Report"
  },
  "wimData": {
    "viewOptions": "Možnosti zobrazení",
    "overspeed": "Překročení rychlosti",
    "legal": "V limitu",
    "unknown": "Neznámé",
    "alertsOn": "Upozornění zapnuta – zvuk při porušení",
    "alertsOff": "Upozornění vypnuta – kliknutím zapnete zvuk při porušení",
    "testAlertSound": "Otestovat zvuk",
    "clearAllFilters": "Vymazat všechny filtry",
    "realtimeOn": "Aktualizace v reálném čase zapnuté – kliknutím vypnete",
    "realtimeOff": "Aktualizace v reálném čase vypnuté – kliknutím zapnete",
    "manualRefresh": "Ruční obnovení",
    "filtersApplied": "{count} filtrů použito",
    "results": "výsledků",
    "clearFilters": "Vymazat filtry",
    "updating": "Aktualizuji…",
    "loading": "Načítám…",
    "loadMore": "Načíst další",
    "allDataLoaded": "Všechna data načtena",
    "totalRecords": "celkem {count} záznamů",
    "vehicleDetails": "Detail vozidla",
    "unknownPlate": "Neznámá SPZ",
    "unknownStation": "Neznámá stanice",
    "unknownValue": "Neznámé",
    "tag": "Tag",
    "filterVehicles": "Filtrovat vozidla",
    "enterTagDetailsHint": "Zadejte údaje tagu pro filtrování při načítání",
    "licensePlate": "SPZ",
    "enterPlateNumber": "Zadejte SPZ",
    "tooltips": {
      "listView": "Zobrazení seznamu",
      "cardsView": "Zobrazení karet",
      "customView": "Vlastní zobrazení",
      "cycleOverviewImages": "Přepínat přehledové snímky",
      "thumbnailsFirst": "Nahrávají se nejdříve náhledy (rychlejší)",
      "fullImagesDirect": "Nahrávají se přímo plné obrázky (pomalejší)",
      "expandAllAxles": "Rozbalit všechny nápravy: přepnout zobrazení detailů náprav",
      "speedToggleList": "Rychlost: přepnout zobrazení údajů o rychlosti v tabulce",
      "imagesToggleList": "Obrázky: přepnout zobrazení sloupce s obrázky v tabulce",
      "backPlateToggleList": "Zadní SPZ: přepnout zobrazení zadní SPZ v LicensePlateView",
      "cardLayout": "Rozložení karet: {n} karet na řádek",
      "cardsPerRow": "karet na řádek",
      "expandedView": "Rozšířené zobrazení: přepnout zobrazení všech detailů karty",
      "axleVerticalLayout": "Svislé rozložení náprav: záhlaví nahoře",
      "axleHorizontalLayout": "Vodorovné rozložení náprav: záhlaví po straně",
      "overlayToggle": "Překryv: přepnout zobrazení informací o vozidle na obrázcích",
      "speedToggleCards": "Rychlost: přepnout zobrazení údajů o rychlosti na kartách",
      "backPlateToggleCards": "Zadní SPZ: přepnout zobrazení zadní SPZ v LicensePlateView",
      "platePosition": "Pozice SPZ: přepnout umístění SPZ do záhlaví místo překryvu na obrázku",
      "recordsCount": "záznamů",
      "nCards": "{n} karet"
    },
    "notifications": {
      "overspeedSingle": "Zjištěno vozidlo překračující rychlost!\nSPZ: {plates}\nRychlost: {speed} km/h",
      "overspeedMultiple": "Zjištěno {count} vozidel překračujících rychlost!\nSPZ: {plates}",
      "overloadSingle": "Zjištěno přetížené vozidlo!\nSPZ: {plates}\nHmotnost: {weight} kg",
      "overloadMultiple": "Zjištěno {count} přetížených vozidel!\nSPZ: {plates}",
      "foundMatchingVehicles": "Nalezeno {count} odpovídajících vozidel"
    }
  },
  "wimTicket": {
    "sectionVehicle": "VOZIDLO",
    "sectionVehicleSub": "Údaje o vozidle a detekci",
    "sectionSpeed": "RYCHLOST",
    "sectionSpeedSub": "Naměřená rychlost vs. povolený limit",
    "station": "Stanice",
    "direction": "Směr",
    "detector": "Detektor",
    "registration": "Registrace",
    "class": "Třída",
    "actual": "SKUTEČNÁ",
    "limit": "LIMIT",
    "legal": "Povolená",
    "excess": "PŘEKROČENÍ",
    "status": "STAV",
    "statusOver": "NAD",
    "statusOk": "OK",
    "speedCertified": "RYCHLOST · CERTIFIKOVÁNO",
    "pageOf": "Strana {i}/{total}",
    "enforcementOnly": "Pouze pro kontrolu",
    "yes": "Ano",
    "no": "Ne",
    "noImage": "Bez obrázku",
    "ticket": "TICKET",
    "nA": "—"
  },
  "wimDashboard": {
    "stationsDashboard": "Přehled stanic",
    "refresh": "Obnovit",
    "stations": "Stanice",
    "stationsListView": "Seznam stanic",
    "speedDashboard": "Přehled rychlosti",
    "mapView": "Mapa",
    "dataLoadingError": "Chyba načítání dat",
    "stationsLabel": "Stanice",
    "detectorsLabel": "Detektory",
    "retry": "Zkusit znovu",
    "timePeriods": {
      "allTime": "Celé období",
      "yearly": "Rok",
      "monthly": "Měsíc",
      "daily": "Den",
      "hourly": "Hodina"
    }
  },
  "wimStations": {
    "onlineStations": "Online stanice",
    "online": "online",
    "detectors": "Detektory",
    "active": "aktivní",
    "maintenance": "Údržba",
    "underMaintenance": "v údržbě",
    "offlineStations": "Offline stanice",
    "offline": "offline",
    "calibratedStations": "Zkalibrované stanice",
    "needCalibration": "vyžadují kalibraci",
    "totalStations": "Celkem stanic",
    "loadingStations": "Načítání stanic...",
    "maintenanceOnly": "(Pouze údržba)",
    "detectorsOnly": "(Pouze detektory)",
    "activeOnly": "(Pouze aktivní)",
    "inactiveOnly": "(Pouze neaktivní)",
    "calibrationOnly": "(Pouze kalibrace)",
    "activityOnly": "(Pouze aktivita)",
    "maintenanceBanner": "ÚDRŽBA",
    "underMaintenanceBanner": "V údržbě",
    "offlineBanner": "OFFLINE",
    "stations": "stanice",
    "stationsPlural": "stanice",
    "totalDirections": "celkem směrů",
    "groupActiveStations": "Aktivní stanice",
    "groupInactiveStations": "Neaktivní stanice",
    "groupMaintenanceStations": "Stanice v údržbě",
    "statusActive": "Aktivní",
    "statusInactive": "Neaktivní",
    "statusMaintenance": "Údržba"
  },
  "wimSpeed": {
    "refreshData": "Obnovit data",
    "speedViolationsAllTime": "Překročení rychlosti – celé období",
    "speedViolationsToday": "Překročení rychlosti – dnes",
    "speedViolationsThisMonth": "Překročení rychlosti – tento měsíc",
    "speedViolationsThisYear": "Překročení rychlosti – tento rok",
    "allTime": "Celé období",
    "today": "Dnes",
    "live": "Live",
    "monthly": "Měsíčně",
    "yearly": "Ročně",
    "speedViolationRateAnalysis": "Analýza míry překročení rychlosti",
    "selectDataToDisplay": "Vyberte data k zobrazení:",
    "totalTraffic": "Celkový provoz",
    "speedViolations": "Překročení rychlosti",
    "detailedSpeedStatistics": "Detailní statistiky rychlosti",
    "topStationsBySpeedViolations": "Stanice s nejvíce překročeními",
    "traffic": "Provoz",
    "violations": "Porušení",
    "speedViolationsList": "Seznam překročení rychlosti",
    "speedViolationsListSubtitle": "Jednotlivé záznamy překročení rychlosti z CAM Report",
    "registrationNumber": "Registrace",
    "stationName": "Stanice",
    "vehicleClass": "Třída vozidla",
    "speedLimit": "Povolená rychlost (km/h)",
    "actualSpeed": "Skutečná rychlost (km/h)",
    "speedExcess": "Překročení (km/h)",
    "violationTime": "Čas",
    "loadViolations": "Načíst porušení",
    "noViolationsFound": "Žádná překročení rychlosti nenalezena",
    "violationsCount": "{count} porušení"
  },
  "wimReports": {
    "title": "Reporty provozu (WIM)",
    "subtitle": "Analytika a přehledy pro provoz z měření za jízdy",
    "refresh": "Obnovit",
    "configTitle": "Nastavení reportu",
    "configSubtitle": "Vyberte typ reportu a parametry pro vytvoření analýzy",
    "reportType": "Typ reportu",
    "reportTypePlaceholder": "Vyberte typ reportu",
    "dateRange": "Rozsah dat",
    "station": "Stanice",
    "allStations": "Všechny stanice",
    "vehicleClass": "Třída vozidla",
    "allClasses": "Všechny třídy",
    "generateReport": "Vygenerovat report",
    "exportOptions": "Export",
    "summaryStatistics": "Souhrn",
    "detailedData": "Detailní data",
    "generatingReport": "Generuji report…",
    "noDataTitle": "Žádná data",
    "noDataText": "Pro zadaná kritéria nebyla nalezena data. Upravte filtry a zkuste to znovu.",
    "stats": {
      "totalRecords": "Počet záznamů",
      "totalTraffic": "Celkový provoz",
      "speedViolations": "Překročení rychlosti",
      "weightViolations": "Přetížení",
      "axleViolations": "Přetížení nápravy",
      "dimensionViolations": "Rozměrové porušení"
    },
    "reportTypes": {
      "trafficFlow": "Report průtoku dopravy",
      "totalHourly": "Souhrn po hodinách",
      "totalDaily": "Souhrn po dnech",
      "totalMonthly": "Souhrn po měsících",
      "totalYearly": "Souhrn po rocích",
      "stationHourly": "Stanice – po hodinách",
      "stationDaily": "Stanice – po dnech",
      "stationMonthly": "Stanice – po měsících",
      "stationYearly": "Stanice – po rocích",
      "vehicleClassStationHourly": "Třída + stanice – po hodinách",
      "vehicleClassStationDaily": "Třída + stanice – po dnech",
      "vehicleClassStationMonthly": "Třída + stanice – po měsících",
      "vehicleClassStationYearly": "Třída + stanice – po rocích",
      "dailyHourly": "Agregace den/hodina"
    },
    "columns": {
      "date": "Datum",
      "station": "Stanice",
      "vehicleClass": "Třída vozidla",
      "heightViolations": "Překročení výšky",
      "widthViolations": "Překročení šířky",
      "lengthViolations": "Překročení délky",
      "trafficAlerts": "Dopravní upozornění",
      "hour": "Hodina",
      "day": "Den",
      "month": "Měsíc",
      "year": "Rok"
    },
    "charts": {
      "dataVisualizations": "Vizualizace dat",
      "chartsSubtitle": "Celkový provoz a překročení rychlosti",
      "trafficOverview": "Přehled provozu",
      "speedViolationsOverTime": "Překročení rychlosti v čase",
      "speedVsTraffic": "Rychlost vs. provoz"
    },
    "export": {
      "pdf": "PDF",
      "excel": "Excel",
      "csv": "CSV",
      "json": "JSON"
    }
  }
}
